import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Handles scroll behaviour across client-side navigation:
// - Pathname change with no hash → scroll to top
// - Pathname change with a hash  → smooth-scroll to the target element
// - Hash change on the same page → smooth-scroll to the target element
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait one frame so the destination page has rendered
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.replace(/^#/, ""));
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
      });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
